import {utils} from '@wallaby-ui/core';

export default function unaccentTextComparator(filter, value, filterText) {
  const filterTextLoweCase = utils.StringUtils.stripDiacritics(
    filterText.toLowerCase()
  );
  const valueLowerCase = utils.StringUtils.stripDiacritics(
    value.toString().toLowerCase()
  );
  let index;
  switch (filter) {
    case 'contains':
      return valueLowerCase.indexOf(filterTextLoweCase) >= 0;
    case 'notContains':
      return valueLowerCase.indexOf(filterTextLoweCase) === -1;
    case 'equals':
      return valueLowerCase === filterTextLoweCase;
    case 'notEqual':
      return valueLowerCase !== filterTextLoweCase;
    case 'startsWith':
      return valueLowerCase.indexOf(filterTextLoweCase) === 0;
    case 'endsWith':
      index = valueLowerCase.lastIndexOf(filterTextLoweCase);
      return (
        index >= 0 &&
        index === valueLowerCase.length - filterTextLoweCase.length
      );
    default:
      // should never happen
      console.warn(`invalid filter type ${filter}`);
      return false;
  }
}
